import { IconSwitchVertical } from "@tabler/icons-react";
import { OrganisationOUT } from "api-client";
import clsx from "clsx";
import Tooltip from "components/Tooltip";
import OrganisationLogo from "features/Organisation/components/OrganisationLogo";
import React from "react";
import { useTranslation } from "react-i18next";

interface OrganisationListProps {
  onClick: (org: OrganisationOUT) => void;
  otherOrganisations: OrganisationOUT[];
}
function OrganisationsList(props: OrganisationListProps) {
  const { t } = useTranslation();

  if (props.otherOrganisations.length === 0) return null;
  return (
    <>
      <div
        className={clsx(
          "flex items-center bg-gray-50 text-gray-500 text-xs",
          "font-medium py-1 px-4 border-y border-gray-300"
        )}
      >
        <IconSwitchVertical stroke={2.5} size={20} className="mr-2" />
        {t("organisationSettings.changeOrganiasation")}
      </div>
      <div className="overflow-y-auto max-h-[calc(100vh-600px)]">
        {props.otherOrganisations.map((org) => (
          <div
            key={org.id}
            className={clsx(
              "flex px-4 py-2 items-center cursor-pointe transition cursor-pointer text-gray-700",
              "hover:bg-gray-100"
            )}
            onClick={() => props.onClick(org)}
          >
            <OrganisationLogo organisation={org} className="w-5 h-5" />
            <Tooltip
              truncate
              className="pl-2 whitespace-nowrap text-sm font-medium max-w-[230px]"
            >
              {org?.name}
            </Tooltip>
          </div>
        ))}
      </div>
    </>
  );
}
export default OrganisationsList;
